import { Component } from '@angular/core';

@Component({
  selector: 'app-check-status',
  standalone: true,
  imports: [],
  templateUrl: './check-status.component.html',
  styleUrl: './check-status.component.css'
})
export class CheckStatusComponent {

}
